import { render, staticRenderFns } from "./CreateRuleInactiveModal.vue?vue&type=template&id=358c662c&"
import script from "./CreateRuleInactiveModal.vue?vue&type=script&lang=js&"
export * from "./CreateRuleInactiveModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateRuleInactiveModal.vue?vue&type=style&index=0&id=358c662c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports